<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import { formatNumber, globalCurrencyTag, isDirectionRTL } from '../../../common/util';
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';
  import { productDetails } from '../store/pdp_store';
  import VDivider from './VDivider.svelte';

  export let data: any;

  const {
    unbxdSearchConfig: { tasheelInfo },
    lang,
    encodedContextPath,
    bnplBaseetaPaymentModeEnabled,
  } = getAppConfig();

  $: productSellingPrice =
    data?.discountPrice === null ? data?.price?.formattedValue : data?.discountPrice?.formattedValue;
  $: hasDiscount = data?.discountPrice !== null;

  $: currentTasheelPriceValue =
    (data?.tasheelPriceValuesList && data?.tasheelPriceValuesList.length > 0 && data?.tasheelPriceValuesList[0]) ||
    null;
  $: tasheelPrice = currentTasheelPriceValue && currentTasheelPriceValue.priceValueTasheel.formattedValue;
  const tasheelInstallMonths = window['ACC'].config.unbxdSearchConfig.tasheelInfo.tasheelInstallmentMonths;
  $: tasheelPercentage = currentTasheelPriceValue && currentTasheelPriceValue.tasheelPercentage;

  export let showDiscountUp = true;
  const isRTL = isDirectionRTL();

  const handleTasheelDrawer = async () => {
    /* TO do : ned to verify, ehen to show popup */
    // $openExtraDrawer = true;
    let url = $productDetails && $productDetails.tasheelContentUrl;
    url = encodedContextPath + url;
    window.open(url);
  };
</script>

<section class="product_price" class:showDiscountUp>
  <div class="product_price__left">
    {#if hasDiscount && showDiscountUp && data?.percentageDiscount?.formattedValue}
      <div class="percent-discount">
        {data?.percentageDiscount?.formattedValue}% <Text key="extra.product.cashback.off" />
      </div>
    {/if}

    <div class="price-row">
      <div class="amount-info">
        <Text key="jood.price.with.currency" args={[globalCurrencyTag, formatNumber(productSellingPrice)]} />
      </div>
      <span class="vat-info"><Text key="extra.vatLable" /></span>
    </div>
    {#if hasDiscount}
      <div class="discount-row">
        <div class="old-price">
          {formatNumber(data?.price?.formattedValue)}
        </div>
        <div class="price-savings">
          <Text key="extra.product.cashback.save" />
          <Text
            key="jood.price.with.currency"
            args={[globalCurrencyTag, formatNumber(data?.savingAmount?.formattedValue)]}
          />
        </div>
        {#if !showDiscountUp && data?.percentageDiscount?.formattedValue}
          <div class="percent-discount">
            {data?.percentageDiscount?.formattedValue}% <Text key="extra.product.cashback.off" />
          </div>
        {/if}
      </div>
    {/if}
    {#if data?.offersLabel && data?.offersLabel.length > 0}
      <div class="offers-row">
        <div class="offer-options">
          {data?.offersLabel}
          <Icon type="font" glyph="chevron_down" mobileSize={14} desktopSize={14} />
        </div>
      </div>
    {/if}
  </div>

  {#if data?.tasheelPriceValuesList && data?.tasheelPriceValuesList.length > 0 && bnplBaseetaPaymentModeEnabled}
    <VDivider />
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      class="product_price__right"
      class:tag_available_price={hasDiscount && showDiscountUp}
      on:click={() => {
        handleTasheelDrawer();
      }}
    >
      <div class="price-row">
        <div class="amount-info tasheel">
          {@html lang === 'en' ? globalCurrencyTag + ' ' : ''}<span class="amount"
            >{formatNumber(tasheelPrice)}{@html lang === 'ar' ? ' ' + globalCurrencyTag : ''}/<Text
              key="extra.pdp.monthLable"
            /></span
          >
        </div>
        <span class="tasheel-info hide-on-desktop">
          <Icon
            type="url"
            glyph={`${tasheelInfo.tasheelIconUrl ? tasheelInfo.tasheelIconUrl : data?.tasheelImageUrl}`}
            mobileSize={16}
            desktopSize={25}
          />
        </span>
        <span class="tasheel-info hide-on-mobile">
          <Icon
            type="url"
            glyph={`${tasheelInfo.tasheelImageUrl ? tasheelInfo.tasheelImageUrl : data?.tasheelImageUrl}`}
            mobileSize={16}
            desktopSize={25}
          />
        </span>
      </div>
      <div class="finance-row">
        <div class="finance-text">
          <Text key="extra.tasheel.priceValue.desc" args={[tasheelPercentage, tasheelInstallMonths]} />
        </div>
      </div>
      <div class="finance-options-row">
        <div class="offer-options">
          <Text key="extra.product.cashback.finance.option" />
          <span class="offer-options_icon" class:rtl={isRTL}>
            {#if isRTL}
              <Icon type="font" glyph="chevron_left" mobileSize={14} desktopSize={14} />
            {:else}
              <Icon type="font" glyph="chevron_right" mobileSize={14} desktopSize={14} />
            {/if}
          </span>
        </div>
      </div>
    </div>
  {/if}
</section>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .product_price {
    display: flex;
    color: $neutral-dark-01;
    gap: 8px;
    background-color: $primary-white;
    // padding: 24px 16px 0;

    @include desktop-max-width {
      & > div {
        width: 50%;
      }
      div.product_price__right {
        padding-left: 8px;
      }
    }
  }
  .price-row,
  .discount-row {
    display: flex;
    align-items: baseline;
  }
  .price-row {
    gap: 4px;
    .amount-info {
      font-weight: 700;
      font-size: 14px;
      line-height: 16px;
      @include desktop-min-width {
        margin-bottom: 4px;
        font-size: 18px;
        line-height: 20px;
      }
      &.tasheel {
        margin-bottom: 4px;
        font-weight: 700;
      }
      .amount {
        font-weight: 700;
      }
    }
  }
  .discount-row {
    align-items: center;
    gap: 6px;
  }
  .vat-info {
    color: $neutral-dark-04;
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
  }
  .old-price {
    text-decoration: line-through;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
  }
  .price-savings {
    color: $extraTagBg;
    font-weight: 700;
    font-size: 12px;
    line-height: 15px;
  }
  .percent-discount {
    color: $extraTagTextColor;
    background: $extraTagBg;
    padding: 4px 8px;
    border-radius: 5px;
    font-weight: 700;
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    white-space: nowrap;
    max-width: max-content;
    margin-bottom: 5px;
    @include desktop-min-width {
      margin-bottom: 12px;
    }
  }
  .offer-options {
    color: $icon-only-icon-blue;
    margin-top: 6px;

    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
  }
  .tasheel-info {
    align-self: center;
    // width: 13px;
    // object-fit: contain;
    // object-position: center bottom;
    :global(.img-icon) {
      aspect-ratio: auto;
      height: auto;
      max-height: 16px;
    }
  }
  .finance-text {
    font-weight: 400;
    font-size: 11px;
    line-height: 12px;
  }

  @include desktop-min-width {
    .product_price {
      gap: 16px;
      // padding: 48px 0 0;
    }
    .price-row {
      .amount-info {
        font-weight: 700;
        font-size: 28px;
        line-height: 32px;
        white-space: nowrap;
        .amount {
          font-weight: 700;
        }
      }
    }
    .vat-info {
      font-size: 12px;
      line-height: 14px;
      white-space: nowrap;
    }
    .tasheel-info {
      width: 48px;
      height: 32px;
      // object-position: center;
      // transform: translateY(5px);
      :global(.img-icon) {
        aspect-ratio: auto;
        max-height: 25px;
      }
    }
    .old-price,
    .price-savings {
      font-size: 16px;
      line-height: 18px;
    }
    .offer-options {
      margin-top: 13px;
    }
    .finance-text {
      font-size: 16px;
      line-height: 18px;
    }
  }
  .product_price__right {
    cursor: pointer;
  }
  .tag_available_price {
    margin-top: 20px;
  }
  .product_price:not(.showDiscountUp) {
    .product_price__right {
      margin-top: 0px;
    }

    .percent-discount {
      @include desktop-min-width {
        margin-bottom: 0px;
      }
    }
  }

  .product_price__left {
    @include desktop-min-width {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
  * :global {
    .offer-options_icon.rtl .img-icon {
      @include desktop-min-width {
        transform: rotate(180deg);
      }
    }
  }

  :global {
    html.rtl {
      .price-row {
        .amount-info {
          display: flex;
          gap: 4px;
          span.amount {
            display: inline-flex;
            gap: 4px;
          }
        }
      }
    }
  }
</style>
